export default "/_next/static/images/play-edba3a0eca1c1eba99cfa7fd72313452.svg";